import script from "./RoleForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleForm.vue?vue&type=script&setup=true&lang=js"

import "./RoleForm.vue?vue&type=style&index=0&id=77ac5994&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77ac5994"]])

export default __exports__